import { Component, OnInit, AfterViewInit } from '@angular/core';
import {Location} from '@angular/common';
declare var $: any;

@Component({
  selector: 'app-parking-managment',
  templateUrl: './parking-managment.component.html',
  styleUrls: ['./parking-managment.component.css']
})
export class ParkingManagmentComponent implements OnInit, AfterViewInit {

  constructor(private location: Location) { }

  ngOnInit() {
  }

  ngAfterViewInit(): void {

    // slide the content 
    $(window).scroll(function () {
      $(".slideanim").each(function () {
        var pos = $(this).offset().top;
        var winTop = $(window).scrollTop();
        if (pos < winTop + 680) {
          $(this).addClass("slide");
        }
      });
    });

  }
  public back(){
    this.location.back();
  }
}
